import { render } from "./services.vue?vue&type=template&id=62b88a62&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"

import "./services.vue?vue&type=style&index=0&id=62b88a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b88a62"]])

export default __exports__